<template>
  <div class="container">
    <header class="header">
      <div class="logout"> {{ userName }}
        <DButton color="primary" label="Logout" @click="logout" style="margin-left: 16px;" />
      </div>
      <h2 style="color: black;">Dashboards</h2>
    </header>

    <main class="content">
      <ProgressDialog :loading="dashboardState.isLoading" loadingText="Loading dashboards..." />
      <div class="dashboard-list">
        <DashboardListItem v-for="dashboard in dashboardState.dashboardList" :key="dashboard.id" :item="dashboard" />
      </div>
    </main>
    <footer class="footerStyle">
      <div>© 2024 - HighQ</div>
    </footer>
  </div>
</template>

<script setup>
import { onMounted, inject, ref } from 'vue'
import DashboardListItem from '@components/DashboardListItem.vue'
import ProgressDialog from '@components/ui/ProgressDialog.vue'
import DButton from '@components/ui/DButton.vue'
import { useKeycloak } from '@plugins/keycloak'

const dashboardState = inject('dashboardState')
const keycloakInstance = useKeycloak()
const userName = ref('')

const setUserName = async () => {
  if (!keycloakInstance){
    console.error('keycloak not available')
  }
  try {
    const userInfo = await keycloakInstance.loadUserInfo()
    userName.value = userInfo.name
  } catch (err) {
    console.error('Failed to load user info:', err)
  }
}

function logout() {
  keycloakInstance?.logout()
}

onMounted(async () => {
  await setUserName()
  await dashboardState.loadDashboardList()
})
</script>

<style lang="scss" scoped>
.dashboard-list {
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px;
}
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.content {
  flex-grow: 1;
  overflow-y: auto;
  background-color: #f5f5f5;
}

h1 {
  margin: 16px;
}

.logout {
  position: absolute;
  right: 16px;
  color: black;
  margin: 16px;
}

.footerStyle {
  background-color: #f5f5f5;
  color: black;
  padding: 16px;
  text-align: center;
  height: 50px;
}

.header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 46px 0 46px 0;
  background-color: #f5f5f5;
  color: black;
  height: 60px;
}
</style>

